/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import Loading from '../../components/Loading';
import { CreateSessionDto } from '../../dtos/CreateSessionDto';
import { useAuthApi } from '../../hooks/useAuthApi';
import { useAuthCtx } from '../../hooks/useAuthCtx';
import { useUserProfileApi } from '../../hooks/useUserProfileApi';

function extractOriginFromJwt(token: string): string | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    let payload = parts[1];
    payload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const pad = payload.length % 4;
    if (pad) payload += '===='.slice(0, 4 - pad);
    const decoded = JSON.parse(atob(payload));
    if (typeof decoded.origin !== 'string' || !decoded.origin.trim()) return null;
    new URL(decoded.origin);
    return decoded.origin;
  } catch {
    return null;
  }
}

interface IProps {
  sso_id: string;
  sso_token: string;
}

export const SsoLoginFlow: React.FC<IProps> = ({ sso_id, sso_token }) => {
  const history = useHistory();
  const user_profile_api = useUserProfileApi();
  const { on_auth_success, logout } = useAuthCtx();
  const auth_api = useAuthApi();

  useEffect(() => {
    const dto: CreateSessionDto = {
      sso_id,
      sso_token
    };
    const sso_origin_url = extractOriginFromJwt(sso_token);

    auth_api
      .login(dto)
      .then((r) => {
        on_auth_success({ result: r, sso_token, sso_id, sso_origin_url });
        history.replace('/pesquisa/todos');

        user_profile_api.update({ name: r.name, picture: r.picture });
      })
      .catch(logout);
  }, []);

  return <Loading />;
};
